// ─── Angular Imports ───────────────────────────────────────────────────────────
import { Component, ChangeDetectionStrategy } from '@angular/core';

// ─── Application Imports ───────────────────────────────────────────────────────
import { AuthService } from 'src/app/services/auth.service';
import { Permission } from 'src/app/constants/permission.constant';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class DashboardComponent {
  Permission = Permission;

  constructor(public authService: AuthService) {}
}
